module.exports = __webpack_public_path__ + "img/japan-logo-icon.df6d04bb.png";